import { render, staticRenderFns } from "./plane.vue?vue&type=template&id=3bfcb686&scoped=true"
import script from "./plane.vue?vue&type=script&lang=js"
export * from "./plane.vue?vue&type=script&lang=js"
import style0 from "./plane.vue?vue&type=style&index=0&id=3bfcb686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcb686",
  null
  
)

export default component.exports